import { useState } from 'react';
import { useUserStatus } from '../../context/UserStatusContext';
import styles from './DashboardModules.module.css';
import widgetStyles from './WidgetStyles.module.css';

const ALL_ACHIEVEMENTS = {
  THE_FOUNDER: {
    icon: 'fa-rocket',
    title: 'Founder',
    description: 'Create your Digital Passport.',
  },
  THE_ANALYST: {
    icon: 'fa-brain',
    title: 'Analyst',
    description: 'Complete the basic personality test.',
  },
  THE_CREATOR: {
    icon: 'fa-paint-brush',
    title: 'Creator',
    description: 'Build your first Creative Persona.',
  },
  THE_SOCIALITE: {
    icon: 'fa-user-friends',
    title: 'Socialite',
    description: 'Create your first Public Profile.',
  },
  THE_CONNECTOR: {
    icon: 'fa-link',
    title: 'Connector',
    description: 'Link a second social account.',
  },
  THE_STORYTELLER: {
    icon: 'fa-book-open',
    title: 'Storyteller',
    description: "You've answered all the relfection questions.",
  },
};

const AchievementModal = ({ achievement, isEarned, onClose }) => (
  <div className={styles.modalOverlay} onClick={onClose}>
    <div className={styles.modalContent}>
      <i
        className={`fas ${achievement.icon} ${styles.modalIcon} ${isEarned ? styles.earned : ''}`}
      ></i>
      <h3>{achievement.title}</h3>
      <p>{achievement.description}</p>
      <span
        className={`${styles.modalStatus} ${isEarned ? styles.earned : ''}`}
      >
        {isEarned ? 'Unlocked' : 'Locked'}
      </span>
    </div>
  </div>
);

const AchievementsModule = ({ isComplete }) => {
  const { userStatus } = useUserStatus();
  const [selectedAchievement, setSelectedAchievement] = useState(null);
  const earnedAchievements = userStatus?.achievements || [];

  return (
    <>
      <div
        className={`${styles.moduleCard} ${isComplete ? widgetStyles.completed : ''}`}
      >
        <div className={styles.moduleHeader}>
          <h5>Achievements</h5>
        </div>
        <div className={styles.moduleContent}>
          <div className={styles.achievementsGrid}>
            {Object.entries(ALL_ACHIEVEMENTS).map(([key, achievement]) => {
              const isEarned = earnedAchievements.includes(key);
              return (
                <div
                  key={key}
                  className={styles.achievementWrapper}
                  onClick={() =>
                    setSelectedAchievement({ ...achievement, isEarned })
                  }
                >
                  <div
                    className={`${styles.achievement} ${isEarned ? styles.earned : ''}`}
                    title={achievement.description}
                  >
                    <i className={`fas ${achievement.icon}`}></i>
                  </div>
                  <span className={styles.achievementTitle}>
                    {achievement.title}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {selectedAchievement && (
        <AchievementModal
          achievement={selectedAchievement}
          isEarned={selectedAchievement.isEarned}
          onClose={() => setSelectedAchievement(null)}
        />
      )}
    </>
  );
};

export default AchievementsModule;
